// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FE5_2","largestCol":"styles_largestCol__26Cea","smallestCol":"styles_smallestCol__wCaA0"};